import React from 'react';
import Immutable from 'immutable';

import type { CouponStatus } from 'js/src/client';
import { CouponNode } from 'js/src/components/pricing/CouponNode';
import type { UPGRADE_STATUS } from 'js/src/components/pricing/types';
import { UpgradeNode } from 'js/src/components/pricing/UpgradeNode';

type Props = {
    couponStatus: CouponStatus | null;
    upgradeStatus?: UPGRADE_STATUS;
    planName?: string;
    retryUpgradeWithNewCard: VoidFunction;
};

const NotificationBlock = React.memo(function NotificationBlock({
    couponStatus,
    upgradeStatus,
    planName,
    retryUpgradeWithNewCard,
}: Props) {
    const prevPropsRef = React.useRef<Props | null>(null);

    React.useEffect(() => {
        const prevProps = prevPropsRef.current;
        if (prevProps) {
            // scroll to top of page
            if (
                !(
                    Immutable.is(couponStatus, prevProps.couponStatus) &&
                    upgradeStatus === prevProps.upgradeStatus &&
                    planName === prevProps.planName
                )
            ) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }
        }
        prevPropsRef.current = { couponStatus, upgradeStatus, planName, retryUpgradeWithNewCard };
    }, [couponStatus, planName, retryUpgradeWithNewCard, upgradeStatus]);

    return (
        <>
            <UpgradeNode
                upgradeStatus={upgradeStatus}
                planName={planName}
                retryUpgradeWithNewCard={retryUpgradeWithNewCard}
            />
            <CouponNode couponStatus={couponStatus} />
        </>
    );
});

export default NotificationBlock;
